import React from 'react';
import './CardComponents.css';
import languageManager from '../../../utils/languageManager';

// 通用卡片组件
const CommonCard = ({ 
  title, 
  subtitle, 
  children, 
  onAdd,
  addButtonText = languageManager.t('common.add'),
  scrollDirection = "vertical" // 滚动方向：vertical(上下) 或 horizontal(左右)
}) => {
  return (
    <div className="card-component common-card">
      {/* 统一的添加按钮 */}
      <button 
        className="common-add-button"
        onClick={onAdd}
      >
        {addButtonText}
      </button>
      
      {/* 统一的卡片头部 */}
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        <p className="card-subtitle">{subtitle}</p>
      </div>
      
      {/* 卡片内容区域 - 支持滚动 */}
      <div className={`card-content card-content-${scrollDirection}`}>
        {children}
      </div>
    </div>
  );
};

export default CommonCard; 